import { action, observable } from 'mobx';
import { ajax } from '@clouderwork/ywk';

/**
 * @module:  动态相关
 * @author Liang Huang
 * @date 2020-10-15 14:33:05
 */

class Trend {
  @observable fetching: string = 'init';
  @action.bound
  async getFeedList(params, isPullOrPush?: boolean) {
    if (!isPullOrPush) {
      this.fetching = 'pending';
    }
    const res = await ajax.getJson('/api/feeds/list', params);
    this.fetching = 'done';
    return res;
  }

  @action.bound
  async readFeed(feedId: number | string) {
    return await ajax.post('/api/feeds/read', { feed_id: feedId });
  }

  @action.bound
  async getStatistic() {
    return await ajax.getJson('/api/tasks/app/count');
  }
}

export default Trend;
